const initialReportState = {
    reportSummary: {
        newly_added: null,
        newly_restarted: null,
        newly_registered: null,
        newly_transferred: null,
        newly_re_challenged: null,
        total_active: null,
        due_for_the_week: null,
        max_dispensing: null,
        overdue_patients: 0,
    },
    reportChartData: {
        data: null,
        meta: {
            filters: {
                end_date: null,
                grouping: null,
                period: null,
                start_date: null,
            },
            reports: {
                amber_patients: {
                    blood_results_count: null,
                    patients_count: null,
                },
                astm_devices: {
                    blood_results_count: null,
                    patients_count: null,
                },
                overdue_patients: {
                    blood_results_count: null,
                    patients_count: null,
                },
                red_patients: {
                    blood_results_count: null,
                    patients_count: null,
                },
            },
        },
    },
    patientGrid: {
        filters: {},
    },
    selectedPeriod: { period: 'week' },
};

const Reports = {
    namespaced: true,
    state: {
        reportChartData: initialReportState.reportChartData,
        reportSummary: initialReportState.reportSummary,
        selectedPeriod: initialReportState.selectedPeriod,
        gridTitle: null,
        selectedPeriodString: null,
        patientGrid: initialReportState.patientGrid,
    },
    getters: {
        getReports: (state) => {
            return state.reports;
        },
        selectedPeriod: (state) => {
            return state.selectedPeriod;
        },
    },
    mutations: {
        SET_GRID_TITLE(state, title) {
            state.gridTitle = title;
        },
        SET_SELECTED_PERIOD_STRING(state, selectedPeriod) {
            state.selectedPeriodString = selectedPeriod;
        },
        SET_REPORTS_PERIOD(state, selectedPeriod) {
            state.selectedPeriod = selectedPeriod;
            if (selectedPeriod.period) {
                _.set(state, 'patientGrid.filters.period', selectedPeriod.period);
            }
        },
        SET_REPORTS_CHART_DATA(state, chartData) {
            state.reportChartData.data = chartData;
        },
        SET_REPORTS_CHART_META(state, chartMeta) {
            state.reportChartData.meta = chartMeta;
        },
        SET_REPORTS_SUMMARY(state, summaryData) {
            state.reportSummary = summaryData;
        },
        SET_PATIENT_GRID_FILTERS(state, filters) {
            state.patientGrid.filters = filters;
        },
    },
    actions: {
        setSelectedPeriodString({ commit }, selectedPeriod) {
            commit('SET_SELECTED_PERIOD_STRING', selectedPeriod);
        },
        setGridTitle({ commit }, title) {
            commit('SET_GRID_TITLE', title);
        },
        setReportsPeriod({ commit }, period) {
            commit('SET_REPORTS_PERIOD', period);
        },
        setPatientsGridFilters({ commit }, filters) {
            commit('SET_PATIENT_GRID_FILTERS', filters);
        },
        fetchReportsChartData({ commit }, params) {
            axios
                .get(route('api.v1.reports.charts-data', { ...params }))
                .then((res) => {
                    const meta = { reports: fixResponse(res.data.meta.reports), filters: res.data.meta.filters };
                    const data = { ...fixResponse(res.data.data) };

                    commit('SET_REPORTS_CHART_DATA', data);
                    commit('SET_REPORTS_CHART_META', meta);
                })
                .catch(() => {
                    commit('SET_REPORTS_CHART_DATA', initialReportState.reportChartData.data);
                    commit('SET_REPORTS_CHART_META', initialReportState.reportChartData.meta);
                });
        },
        fetchReportsSummary({ commit, getters }) {
            const selectedPeriod = _.clone(getters.selectedPeriod);
            let period = new Object();
            if (selectedPeriod.period === 'custom') {
                period.start_date = selectedPeriod.start_date;
                period.end_date = selectedPeriod.end_date;
            }
            if (selectedPeriod.period !== 'custom') {
                period.period = selectedPeriod.period;
            }
            axios.get(route('api.v1.reports.patients-stats', period)).then((res) => {
                if (!res) {
                    return;
                }
                const data = _.clone(res.data);
                if (data && !data.overdue_patients) {
                    data['overdue_patients'] = initialReportState.reportSummary.overdue_patients;
                }
                commit('SET_REPORTS_SUMMARY', data);
            });
        },
    },
};

function fixResponse(res) {
    return _.mapKeys(res, (v, key) => {
        return key.replaceAll('-', '_');
    });
}

export default Reports;
